import { getLaborCostCalc } from "../api/generated/wrappers/backdata";
import { getMarketWageUnitPrice } from "../api/generated/wrappers/backdata";
import { getOutputRatio } from "../api/generated/wrappers/backdata";
import { createQueryKeys } from "./create-query-keys";
const laborCostQueryKeys = createQueryKeys("laborCost", {
    laborCostCalc: () => ({
        queryKey: ["laborCostCalc"],
        queryFn: getLaborCostCalc,
    }),
    marketWageUnitPrice: () => ({
        queryKey: ["marketWageUnitPrice"],
        queryFn: getMarketWageUnitPrice,
    }),
    outputRatio: () => ({
        queryKey: ["outputRatio"],
        queryFn: getOutputRatio,
    }),
});
export default laborCostQueryKeys;
